import type { IPerson } from './getDisplayName';
import { getDisplayName } from './getDisplayName';

interface IOrganizationName {
    city?: string | null;
    name?: string | null;
}

export function getDisplayPractitionerAndOrganizationName(
    practitioner: IPerson,
    organization: IOrganizationName
): string {
    let name = getDisplayName(practitioner);

    let organizationName = null;
    if (organization.name && organization.city) {
        organizationName = `${organization.name}, ${organization.city}`;
    } else if (organization.name) {
        organizationName = organization.name;
    } else if (organization.city) {
        organizationName = organization.city;
    }

    if (organizationName) {
        name = `${name} (${organizationName})`;
    }

    return name;
}
